import React from 'react';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import NewsLineBlock from './news_line_block';

const NewsLine = ({ publication, globalIndex }) => {
  const news = useSelector((state) => state.news?.news || []);
  const containerRef = React.useRef(null);

  React.useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const onWheel = (e) => {
      e.preventDefault();
      e.stopPropagation();
      el.scrollLeft += e.deltaY;
    };
    el.addEventListener('wheel', onWheel, { passive: false });
    return () => el.removeEventListener('wheel', onWheel);
  }, []);

  const isDownRef = React.useRef(false);
  const startXRef = React.useRef(0);
  const scrollStartRef = React.useRef(0);
  const [hasDragged, setHasDragged] = React.useState(false);

  const scrollLeft = (e) => {
    e.stopPropagation();
    if (containerRef.current) containerRef.current.scrollBy({ left: -500, behavior: 'smooth' });
  };
  const scrollRight = (e) => {
    e.stopPropagation();
    if (containerRef.current) containerRef.current.scrollBy({ left: 500, behavior: 'smooth' });
  };

  const onMouseDown = (e) => {
    if (!containerRef.current) return;
    isDownRef.current = true;
    setHasDragged(false);
    startXRef.current = e.clientX;
    scrollStartRef.current = containerRef.current.scrollLeft;
    containerRef.current.classList.add(styles.dragging);
  };
  const onMouseMove = (e) => {
    if (!containerRef.current || !isDownRef.current) return;
    const dx = e.clientX - startXRef.current;
    if (Math.abs(dx) > 5) setHasDragged(true);
    containerRef.current.scrollLeft = scrollStartRef.current - dx;
  };
  const endDrag = () => {
    isDownRef.current = false;
    if (containerRef.current) containerRef.current.classList.remove(styles.dragging);
    setTimeout(() => setHasDragged(false), 100);
  };

  if (!news || news.length === 0) return <div className={styles.newsLine}>Новости не найдены</div>;

  return (
    <div className={styles.newsLine}>
      <h2 className={styles.newsTitle}>Новости</h2>
      <div className={styles.newsWrapper}>
        <button className={styles.scrollButton} onClick={scrollLeft} aria-label='Прокрутить влево'>
          ‹
        </button>
        <div
          className={styles.newsContainer}
          ref={containerRef}
          onMouseDown={onMouseDown}
          onMouseMove={onMouseMove}
          onMouseUp={endDrag}
          onMouseLeave={endDrag}>
          {news.slice(0, 10).map((item, index) => {
            const pathToFolder =
              item?.path && (item.eng_name || item.blank_name)
                ? 'https://' + item.path + (item.eng_name || item.blank_name) + '/'
                : null;
            const itemsPerPage = 10;
            const sectionPosition = item.section_position || index + 1;
            const pageNumber = Math.ceil(sectionPosition / itemsPerPage);
            const realIndexInNews = news.findIndex((n) => n.eng_name === item.eng_name);
            const newsLineGlobalIndex = sectionPosition;
            return (
              <NewsLineBlock
                key={index}
                item={item}
                path_to_folder={pathToFolder}
                hasDragged={hasDragged}
                blockIndex={`#${realIndexInNews + 1} (стр.${pageNumber})`}
                sectionPageNumber={pageNumber}
                globalIndex={newsLineGlobalIndex}
              />
            );
          })}
        </div>
        <button className={styles.scrollButton} onClick={scrollRight} aria-label='Прокрутить вправо'>
          ›
        </button>
      </div>
    </div>
  );
};

export default NewsLine;
